const trends = [
    {
        category : "Deportes",
        tittle : "CR7 Anuncia su retiro de las canchas",
        noTweets : 1051055
    },
    {
        category : "Musica",
        tittle : "Luis Miguel lanza su cancion de reggeton",
        noTweets : 520520
    },
    {
        category : "Cine",
        tittle : "Robert Downey Jr. regresa como IronMan en Marvel",
        noTweets : 6358408
    },
    {
        category : "Politica",
        tittle : "Donald Trump se niega a dejar la Casa Blanca",
        noTweets : 805156
    },
    {
        category : "Salud",
        tittle : "Covid-19 evoluciona a un nuevo virus mortal para animales y humanos",
        noTweets : 8592606
    },
    {
        category : "Deportes",
        tittle : "Hugo Sanchez anuncia regreso a las canchas con el tigres",
        noTweets : 8526169
    }
];

export {
    trends
}